module.exports = __webpack_public_path__ + "img/alpop-advantages.2ed0bb81.png";